import React from 'react'

const Index = () => {
  return <div>OK</div>
}

export default Index
